import React from 'react'

import ReactModal from 'react-modal';
import styles from './input-entry-dialog.module.scss'
import { ReactComponent as CloseIcon } from 'assets/img/close.svg';

const InputEntryDialog = (
    {
        dialogID,
        closefn,
        saveText,
        isSavingText,
        isSaving,
        isdisabledState,
        cancelText,
        titleText,
        subTitleText,
        saveFn,
        DialogWidth,
        IsOpen,
        childrenComponents,
        classes,
        maxDialogHeight,
        inputHeaderStyling,
        fullScreenContainer,
        inputEntryFooterStyling,
        inputEntryBodyStyling
    }:
        {
            dialogID: string
            closefn: any
            saveText: string
            isSavingText: string
            isSaving: boolean
            isdisabledState?: boolean
            cancelText: string
            titleText: string
            subTitleText?: string
            saveFn: () => void
            DialogWidth?: string
            IsOpen: boolean
            childrenComponents: JSX.Element
            classes?: Array<any>
            maxDialogHeight?: string
            inputHeaderStyling?: string
            fullScreenContainer?: string
            inputEntryFooterStyling?: string
            inputEntryBodyStyling?: string
        }
) => {

    return (
        <ReactModal
            id={dialogID}
            isOpen={IsOpen}
            className={`${styles.inputEntryContainer} ${fullScreenContainer}`}
            style={{
                content: {
                    width: DialogWidth ? DialogWidth : "646px",
                    maxHeight: maxDialogHeight ? maxDialogHeight : "calc(100vh - 135px)",
                },
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 99999,
                }
            }}
        >

            <div className={`${styles.inputEntryHeader} ${inputHeaderStyling ? inputHeaderStyling : ""}`}>
                <h1>{titleText} </h1>
                <span onClick={closefn}>
                    <CloseIcon />
                </span>
            </div>

            {
                subTitleText &&
                <div className={styles.inputEntryDesc}>
                    <span>{subTitleText}</span>
                </div>
            }

            <div className={`${styles.inputEntryBody} ${inputEntryBodyStyling ? inputEntryBodyStyling : ""}`}>
                {childrenComponents}
            </div>

            <div className={`${styles.inputEntryFooter} ${inputEntryFooterStyling ? inputEntryFooterStyling : ""}`}>
                <button
                    className={styles.inputEntryFooterDiscard}
                    onClick={() => closefn()}
                >
                    {cancelText}
                </button>
                <button
                    disabled={isSaving}
                    className={`${styles.inputEntryFooterSave} ${isSaving || isdisabledState ? styles.inputEntryDisableSave : ""}`}
                    onClick={() => saveFn()}
                >
                    {isSaving ? isSavingText : saveText}
                </button>
            </div>

        </ReactModal>
    )
}

export default InputEntryDialog